// Portable, slug-based land detection for the common tenant path (Oman / Jordan / etc.).
// Unlike Bayut KSA — which keys off hardcoded external category IDs — the common path has
// no shared land-id list, so we detect land by category slug. This matches the Land parent
// and every sub-type: `land`, `residential-lands`, `commercial-lands`, `industrial-lands`,
// `agriculture-plots`, etc., while avoiding false positives such as `island` by requiring a
// slug word boundary.
const LAND_SLUG_REGEX = /(^|-)(land|lands|plot|plots)(-|$)/;

export function isLandCategorySlug(slug) {
  if (!slug || typeof slug !== 'string') return false;
  return LAND_SLUG_REGEX.test(slug.toLowerCase().trim());
}
